import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import logoLight from '../../assets/gcm-logo-light.svg';

const Footer: React.FC = () => {
  const [imgError, setImgError] = useState(false);
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              {imgError ? (
                <div 
                  className="h-10 flex items-center justify-center font-bold text-xl"
                  style={{ 
                    maxWidth: '150px'
                  }}
                >
                  GCM FRANCE
                </div>
              ) : (
                <div className="relative flex items-center justify-center bg-transparent">
                  <img 
                    src={logoLight} 
                    alt="GCM FRANCE Logo" 
                    className="h-16 w-auto" 
                    style={{ 
                      objectFit: 'contain',
                      maxWidth: '180px',
                      filter: 'drop-shadow(0 2px 4px rgba(255,255,255,0.1))',
                      transition: 'transform 0.3s ease'
                    }}
                    onError={() => setImgError(true)}
                    onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  />
                </div>
              )}
            </div>
            <p className="mb-4 text-gray-400">
              Votre partenaire de confiance pour tous vos projets de couverture et de rénovation.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-light transition-colors">Accueil</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-primary-light transition-colors">Services</Link>
              </li>

              <li>
                <Link to="/faq" className="text-gray-400 hover:text-primary-light transition-colors">FAQ</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-primary-light transition-colors">Contact</Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary-light mt-1 mr-3" />
                <span className="text-gray-400">60 Rue Moslard, 92700 Colombes, France</span>
              </li>
              <li className="flex items-center">
                <FontAwesomeIcon icon={faEnvelope} className="text-primary-light mr-3" />
                <span className="text-gray-400">gcmcouverture@gmail.com</span>
              </li>
            </ul>
          </div>
          
          {/* Legal Info */}
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Informations Légales</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal-notice" className="text-gray-400 hover:text-primary-light transition-colors">Mentions Légales</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-primary-light transition-colors">Politique de Confidentialité</Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-400 hover:text-primary-light transition-colors">Conditions d'Utilisation</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-gray-500 text-sm flex justify-between items-center">
          <div className="flex items-center">
            <a 
              href="https://aiko-agency.fr/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center hover:opacity-80 transition-opacity"
            >
              <span className="mr-2 text-white text-base font-medium">By aiko</span>
              <img 
                src="/aiko.png" 
                alt="aiko logo" 
                className="h-6 w-auto" 
                onError={(e) => {
                  // Fallback en cas d'erreur de chargement de l'image
                  e.currentTarget.style.display = 'none';
                }}
              />
            </a>
          </div>
          <p>&copy; {currentYear} GCM FRANCE. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
